export const bookingUrl = "https://asiatech.in/booking_engine/index3?token=MjE1MQ==";


export const contactImages = "https://eazotel-client-webp-image.s3.ap-south-1.amazonaws.com/ora-lake-view/contact";
